import React from "react";
import { Box, Button, Typography } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { styled } from "@mui/material/styles";
import { CONTACT_WHATSAPP } from "../../pages/shared/constants";
import { gaEvent } from "../../analytics";

const InfoBox = styled(Box)(({ theme }) => ({
  background: theme.palette.text.primary,
  color: theme.palette.common.white,
  padding: theme.spacing(4),
  borderRadius: theme.spacing(1),
  textAlign: "center",
  marginTop: theme.spacing(2),
}));

const InfoWhatsAppButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.brand.whatsapp,
  color: theme.palette.common.white,
  textTransform: "none",
  fontSize: "1.1rem",
  fontWeight: 700,
  padding: `${theme.spacing(1.5)} ${theme.spacing(4)}`,
  "&:hover": {
    backgroundColor: theme.palette.brand.whatsappHover,
  },
}));

interface WhatsAppInfoSectionProps {
  title: string;
  description: string;
  message: string;
  button: string;
}

const WhatsAppInfoSection: React.FC<WhatsAppInfoSectionProps> = ({
  title,
  description,
  message,
  button,
}) => {
  const url = `https://wa.me/${CONTACT_WHATSAPP}?text=${encodeURIComponent(message)}`;

  return (
    <InfoBox>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" mb={2}>
        {description}
      </Typography>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => gaEvent("whatsapp_click", { source: "service_page" })}
      >
        <InfoWhatsAppButton startIcon={<WhatsAppIcon />}>{button}</InfoWhatsAppButton>
      </a>
    </InfoBox>
  );
};

export default WhatsAppInfoSection;
